import { LegacyHeader, LegacyHeaderProps } from '@bilibili-maoer/prelude'
import { api } from '@bilibili-maoer/web-utils'

import { styled } from '@mui/material'
import { z } from 'zod'

import { notificationUnreadMark } from '~/core/styles'
import { isNot } from '~/core/utils/is'
import { EAnnouncementType } from '~/features/announcements/types'
import { UserApi } from '~/services/fm/user'
import { NewsApi } from '~/services/web/news'
import { EGuildRole } from '~/shared/types/services/user'

const StyledHeaderStartBtn = styled('a')(() => ({
  // eslint-disable-next-line @typescript-eslint/naming-convention -- mui 样式覆盖
  '&:hover': {
    color: 'white !important',
  },
}))

const StyledHeaderLink = styled('a')(({ theme }) => ({
  color: 'white',
  fontSize: 14,
  textDecoration: 'none',
  transition: 'color 0.2s ease',
  // eslint-disable-next-line @typescript-eslint/naming-convention -- mui 样式覆盖
  '&:hover': {
    color: theme.palette.error.main,
  },
}))

const StyledHeaderLinkNotice = styled('i')`
  ${notificationUnreadMark()}
`

const TWebHeader = (props: LegacyHeaderProps) => {
  const { data: roleData } = UserApi.getUserGuildRole.useQuery()
  const { data: userInfo } = UserApi.getUserInfo.useQuery()
  const userId = userInfo?.user && !userInfo.user.is_guest && userInfo.user.user_id
  const { data: newsNotice } = NewsApi.getNotice.useQuery(
    {
      tag_ids: [EAnnouncementType.LiveGuildTag, EAnnouncementType.LiveLiverTag, EAnnouncementType.LiveTag],
    },
    { skip: !userId }
  )
  const roomId = userInfo?.room?.room_id
  const roomUrl = `${api.MISSEVAN_FM_API_PREFIX_URL}${roomId ? `/${roomId}}` : ''}`
  // eslint-disable-next-line no-bitwise
  const isAgentOrOwner = !!((roleData?.role || 0) & EGuildRole.AgentOrOwner)

  const createLink = (text: string, href: string, noticeType: EAnnouncementType) => ({
    text,
    linkItem: () => (
      <li>
        <StyledHeaderLink href={href}>
          {text}
          {!!newsNotice?.data?.notices?.[noticeType] && <StyledHeaderLinkNotice />}
        </StyledHeaderLink>
      </li>
    ),
  })

  const startBtnConfig = {
    renderTitle: (
      <StyledHeaderStartBtn target="_blank" href={roomUrl}>
        我要直播
      </StyledHeaderStartBtn>
    ),
    config: [
      {
        title: '直播中心',
        links: [
          { text: '我要直播', href: roomUrl },
          !!roomId &&
            createLink('主播工作台', `${api.MISSEVAN_FM_API_PREFIX_URL}/user/center`, EAnnouncementType.LiveLiverTag),
          isAgentOrOwner &&
            createLink('公会管理中心', `${api.MISSEVAN_FM_API_PREFIX_URL}/guild`, EAnnouncementType.LiveGuildTag),
        ].filter(isNot(z.boolean())),
      },
      {
        title: '玩转直播',
        links: [
          { text: '直播助手下载', href: `${api.MISSEVAN_API_PREFIX_URL}/x/app/download?device=2` },
          { text: '直播教程', href: `${api.MISSEVAN_LINK_PREFIX_URL}/fm/live-operation` },
          createLink('直播公告', `${api.MISSEVAN_FM_API_PREFIX_URL}/announcement`, EAnnouncementType.LiveTag),
        ],
      },
      !!userId && {
        title: '用户中心',
        links: [
          // TODO: 补充具体等级
          { text: '我的等级', href: `${api.MISSEVAN_FM_API_PREFIX_URL}/user/level` },
          { text: '我的贵族', href: `${api.MISSEVAN_FM_API_PREFIX_URL}/noble/mynoble` },
        ],
      },
    ].filter(isNot(z.boolean())),
  }

  return <LegacyHeader {...props} startBtnConfig={startBtnConfig} />
}

const WebHeader = styled(TWebHeader)(({ theme }) => ({
  zIndex: theme.zIndex.appBar,
  position: 'sticky',
  top: 0,
}))

export default WebHeader
